import React from "react";

import { ExportButtonGraphql } from "components/actions/ExportButtonGraphql";
import ExportEntityPaywallButton from "components/actions/ExportEntityPaywallButton";
import { useOpportunityExport } from "lib/hooks/api/opportunities/useOpportunityExport";
import { useSubscription } from "lib/hooks/subscription";
import { EventDataTypes } from "lib/tracking";
import { convertOpportunityFiltersToSearchRequest, OpportunityFilters } from "../utils";

export default function ExportOpportunitiesButton({
  filters,
  totalCount,
  isLoading,
  selectedOpportunities,
}: {
  filters: OpportunityFilters;
  totalCount?: number;
  isLoading?: boolean;
  selectedOpportunities?: string[];
}) {
  const subscription = useSubscription();
  const authorised = subscription.hasDataTypes("SUPPLIERS") && subscription.hasDataTypes("BUYERS");

  const opportunityExportMutation = useOpportunityExport();

  const totalResults: number =
    selectedOpportunities && selectedOpportunities.length > 0
      ? selectedOpportunities.length
      : totalCount || 0;

  if (!authorised) {
    return <ExportEntityPaywallButton />;
  }

  return (
    <ExportButtonGraphql
      isLoadingTotalResults={isLoading ?? false}
      totalResults={totalResults}
      exportMutation={opportunityExportMutation}
      exportVariables={{
        filters: convertOpportunityFiltersToSearchRequest(filters),
        pagination: {
          pageSize: totalResults + 1,
          page: 1,
        },
        selectedOpportunities: { opportunityIds: selectedOpportunities },
      }}
      exportDataType={EventDataTypes.opportunity}
    />
  );
}
